import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import type { Params } from '@angular/router';
import { LmivNavigationService, LmivProductComponent } from '@libs/services/components';
import { LMIV_SEARCH_QUERY_PARAM } from '@libs/shared/models';

@Component({
  selector: 'ui-product-information',
  templateUrl: './product-information.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LmivNavigationService],
  imports: [LmivProductComponent],
})
export class ProductInformationComponent {
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  protected readonly searchQueryParam: string = LMIV_SEARCH_QUERY_PARAM;
  public readonly queryParams: Signal<Params> = toSignal(this.activatedRoute.queryParams, {
    initialValue: this.activatedRoute.snapshot.queryParams,
  });
}
